/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calm_Blue_Weasel_CryInputs */

const en_calm_blue_weasel_cry = /** @type {(inputs: Calm_Blue_Weasel_CryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Market Token`)
};

/**
* | output |
* | --- |
* | "Market Token" |
*
* @param {Calm_Blue_Weasel_CryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const calm_blue_weasel_cry = /** @type {((inputs?: Calm_Blue_Weasel_CryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calm_Blue_Weasel_CryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_calm_blue_weasel_cry(inputs)
});